import { Button } from '@/components/Button/Button';
import type { Variant as ButtonVariant } from '@components/Button/button.styled';
import { AlertDialog as TamaguiAlertDialog, XStack, YStack } from 'tamagui';

export interface AlertDialogAction {
  label: string;
  onPress?: () => void;
  variant?: ButtonVariant;
  actionType: 'cancel' | 'action';
}

interface AlertDialogProps {
  title: string;
  description: string;
  actions: AlertDialogAction[];
  children: React.ReactNode;
}

export function AlertDialog({
  title,
  description,
  actions,
  children,
}: AlertDialogProps): React.ReactNode {
  return (
    <TamaguiAlertDialog>
      <TamaguiAlertDialog.Trigger asChild>
        {children}
      </TamaguiAlertDialog.Trigger>

      <TamaguiAlertDialog.Portal>
        <TamaguiAlertDialog.Overlay backgroundColor="$shadow" key="overlay" />

        <TamaguiAlertDialog.Content margin="$true" key="content">
          <YStack gap="$true">
            <YStack gap="$2">
              <TamaguiAlertDialog.Title>{title}</TamaguiAlertDialog.Title>
              <TamaguiAlertDialog.Description>
                {description}
              </TamaguiAlertDialog.Description>
            </YStack>

            <XStack gap="$true" justifyContent="flex-end">
              {actions.map((action, index) =>
                action.actionType === 'cancel' ? (
                  <TamaguiAlertDialog.Cancel asChild key={index}>
                    <Button title={action.label} variant="outlined" />
                  </TamaguiAlertDialog.Cancel>
                ) : (
                  <TamaguiAlertDialog.Action asChild key={index}>
                    <Button
                      title={action.label}
                      onPress={action.onPress}
                      variant={action.variant || 'destructive'}
                    />
                  </TamaguiAlertDialog.Action>
                ),
              )}
            </XStack>
          </YStack>
        </TamaguiAlertDialog.Content>
      </TamaguiAlertDialog.Portal>
    </TamaguiAlertDialog>
  );
}
